export default __webpack_public_path__ + "static/media/vishw.de1d0039.jpg";